import type { ContentPage } from "@/lib/content/types";

// MIGRATED (Phase 3): faithful port of the former hand-coded
// app/(homes)/(hrms)/hrms-software/payroll-management-system/overtime-leave-calculations/page.jsx onto the content
// engine (template "hrmsFeature"). Copy, images, links and heading levels
// match the original. SEO still comes from GeneralPageSEOMetadata.json via
// <SEO> (its "overtime-leave-calculations" entry is kept); the seo block below is a fallback.

export const overtimeLeaveCalculations: ContentPage = {
  slug: "payroll-management-system/overtime-leave-calculations",
  template: "hrmsFeature",
  seo: {
    title: "Manage Overtime and Leave with Precision",
    description: "Automate overtime calculations and manage leave deductions accurately with our advanced system, ensuring compliance and employee satisfaction.",
    keywords: [
      "overtime calculation",
      "leave balance management",
      "holiday pay",
      "payroll processing",
      "automated leave deductions.",
    ],
    ogImage: "/assets/data/seoimages/overtime-leave-calculations.webp",
  },
  leaf: {
    hero: {
      caption: "Overtime and Leave Calculations",
      title: "Accurately Calculate Overtime and Manage Leave",
      description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
      h1: "caption",
    },
    split: {
      title: "Efficient Overtime and Leave Management",
      bullets: [
        { title: "Automated Overtime Calculations", description: "Calculate overtime automatically based on hours worked." },
        { title: "Accurate Leave Deductions", description: "Deduct leave from salaries with automatic syncing." },
        { title: "Holiday Pay Management", description: "Adjust payroll for holidays per company policies." },
        { title: "Seamless Leave Tracking", description: "Track leave balances easily to ensure compliance." },
      ],
      image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations_info.webp",
      imageAlt: "overtime-leave-calculations_info",
    },
    cardsHeading: {
      title: "Key Features of Payroll Management System",
      description: "Optimize Payroll management with advanced features designed to streamline tracking, automation, and customization.",
    },
    cards: [
      {
        title: "Payslip Generation",
        href: "/hrms-software/payroll-management-system/payslip-generation",
        description: "Provide clear and detailed payslips automatically each payroll cycle, enhancing transparency and trust with your employees.",
        image: "/assets/images/img/product/hrms/payrollms/payslip-generation_image.webp",
        imageAlt: "payslip-generation",
      },
      {
        title: "Integration with Accounting",
        href: "/hrms-software/payroll-management-system/integration-with-accounting",
        description: "Sync your payroll data directly with your accounting software to streamline financial management and reporting.",
        image: "/assets/images/img/product/hrms/payrollms/integration-with-accounting_image.webp",
        imageAlt: "integration-with-accounting",
      },
      {
        title: "Custom Deductions",
        href: "/hrms-software/payroll-management-system/custom-deductions",
        description: "Tailor deductions for taxes, benefits, and other payroll elements to match your company policies and employee agreements.",
        image: "/assets/images/img/product/hrms/payrollms/custom-deductions.webp",
        imageAlt: "custom-deductions",
      },
      {
        title: "Overtime and Leave Calculations",
        href: "/hrms-software/payroll-management-system/overtime-leave-calculations",
        description: "Streamline how you handle overtime pay and leave deductions, ensuring fairness and compliance in your payroll processes.",
        image: "/assets/images/img/product/hrms/payrollms/overtime-leave-calculations.webp",
        imageAlt: "overtime-leave-calculations",
      },
    ],
    testimonials: {
      title: "200+ Businesses across India love & trust us!",
      description: "Know why Superworks is the best HR software in India",
    },
    bookDemoTitle: "Optimize Your Overtime and Leave Payroll Calculations!",
    relatedBlogsKeyword: "overtime-leave-calculations,overtime-leave-bonus-payroll",
    metaKey: "overtime-leave-calculations",
  },
  sections: [],
};
